import {apiWithToken} from '../../../systems/api';
import {API_URL} from './../../../systems/globalContant';

export default {
    updateRealPaymentAmount: (datas) => apiWithToken.put(API_URL.REAL_PAYMENT_AMOUNT_ORDER.replace("{id}", datas.id) , {...datas}, {loading: false}),
    updateRealRefundAmount: (datas) => apiWithToken.put(API_URL.REAL_REFUND_AMOUNT_ORDER.replace("{id}", datas.id) , {...datas}, {loading: false}),
};